import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Cleanup: remove any previously persisted user-specific performance optimizations
try {
  document.body.classList.remove('optimized-rendering');
  localStorage.removeItem('userNeedsOptimization');
} catch (_) {
  // ignore
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <App />
  </BrowserRouter>
);

// PWA: register service worker in production builds
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch(() => {
        // ignore registration errors
      });
  });
}
